module.exports = __webpack_public_path__ + "static/media/gq.385ac47e.svg";